import React from 'react'

import { Redirect } from '../../shared'
import type { WCDRouteProps } from '..'
import { Page } from '../components/Page'

export const hubsRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: '/money/pensions-and-retirement',
    component: () => <Redirect to="/topic/pensions-and-retirement" />,
  },
  {
    live: true,
    exact: true,
    path: '/topic/:subVerticalSlug',
    component: () => (
      <Page pagePath="sub-vertical/SubVerticalPage" template="Hub Page" context="topic" />
    ),
  },
]
